import { header } from "../utils/header";
import { baseURL } from "../utils/constants";
import { LoginData } from "../utils/types";
import axiosInstance from "../utils/axiosUtil";
import { deleteCookie } from "../utils/cookies";

//User Login
export const userLogin = async ({ email, password }: LoginData) => {
  try {
    const res = await axiosInstance.post(`${baseURL}/user/login`, {
      email: email.trim(),
      password: password.trim(),
    },
    {
      withCredentials: true, 
    }
  );

    console.log("Login response: ", res);
    return res;
  } catch (error) {
    console.error(error);
  }
};

//User QR Login
export const userQRLogin = async (sessionId:string) => {
  try {
    const res = await axiosInstance.post(`${baseURL}/user/qrlogin/session`,{
      session_id: sessionId.trim(),
    },
    {
      withCredentials: true,
    }
  )
    console.log("Login response: ", res);
    return res;
  } catch (error) {
    console.log(error);
  }
};

//Get User Details By User ID
export const getUserDetails = async (user_id: string) => {
  try {
    const res = await axiosInstance.get(`${baseURL}/user/${user_id}`);
    return res;
  } catch (error: any) {
    if (error.response || error.response.status === 403) {
      return error.response;
    } else {
      console.error(error);
    }
  }
};

//Update user details
export const updateUserPassword = async (user_id: string, password: string) => {
  try {
    const res = await axiosInstance.patch(
      `${baseURL}/user/${user_id}`,
      {
        password: password,
      },
      { headers: header() }
    );
    return res;
  } catch (error: any) {
    if (error.response || error.response.status === 403) {
      return error.response;
    } else {
      console.error(error);
    }
  }
};

//Refresh Token
export const hitRefreshToken = async () => {
  try {
    const res = await axiosInstance.post(`${baseURL}/user/refresh`, {},
    {
      withCredentials: true, 
    }
  );
  // console.log("Refresh Token Response: ", res);
    return res;
  } catch (error: any) {
    console.error(error);
      if(error?.response?.status === 401){
        deleteCookie("userID");     
        window.location.href = "/";
      }
    if (error.response || error.response.status === 403) {
      return error.response;
    }
  }
};
